import { postReportChatConversationStop } from 'src/api/report/reportChat';
import { createAppAsyncThunk } from 'src/hooks/hooks';

/** 停止对话 */
export const stopConversation = createAppAsyncThunk(
  'reportChat/stopConversation',
  async (data, { getState }) => {
    const { abortController, conversationId, roundId, currentChat } =
      getState().reportChatReducer;
    // 只有回答中才需要后端停止对话
    if (currentChat && !currentChat.is_finished && conversationId && roundId) {
      try {
        await postReportChatConversationStop({
          conversation_id: conversationId,
          round_id: roundId,
        });
      } catch (error) {
        console.error(error);
      }
    } else {
      abortController?.abort();
    }
    return true;
  },
);
